
<div class="device-header-section" *ngIf="newDeviceSetupStage == 1 || newDeviceSetupStage == 2 || newDeviceSetupStage == 3 || newDeviceSetupStage == 4 || newDeviceSetupStage == 5">
  <h1>Device Setup</h1>
  <p>
    Please go through the following steps to ensure your browser can support video and audio before you start your session.
  </p>
</div>

<div class="device-header-section" *ngIf="newDeviceSetupStage == 0">
  <h1>Welcome</h1>
  <p>
    Your session is about to begin!
  </p>
</div>

<!-- Video Test -->
<step-0-initial *ngIf="newDeviceSetupStage == 0" (OnChanged)="stepChanged($event)"></step-0-initial>

<!-- Video Test -->
<step-1-video *ngIf="newDeviceSetupStage == 1" (OnChanged)="stepChanged($event)"></step-1-video>

<!-- Mic Test -->
<step-2-mic *ngIf="newDeviceSetupStage == 2" (OnChanged)="stepChanged($event)"></step-2-mic>

<!-- Speakers Test -->
<step-3-speakers *ngIf="newDeviceSetupStage == 3" (OnChanged)="stepChanged($event)"></step-3-speakers>

<!-- Speed Test -->
<step-4-speed *ngIf="newDeviceSetupStage == 4" (OnChanged)="stepChanged($event)"></step-4-speed>

<!-- Setup Complete -->
<step-5-complete *ngIf="newDeviceSetupStage == 5" (OnChanged)="stepChanged($event)"></step-5-complete>
